import React from 'react';

import VpnKeyOffIcon from '@mui/icons-material/VpnKeyOff';
import { ListItemButton, ListItemText, ListItemIcon, Tooltip } from '@mui/material';
import { useLanguage } from 'Context/LanguageContext';

const EnableDisableMfaSideMenu = ({ showMfaMenu }) => {
	const lan = useLanguage();
	const title = lan.enableDisableMfa;

	return (
		<Tooltip title={title} placement='right'>
			<ListItemButton onClick={showMfaMenu}>
				<ListItemIcon>
                    < VpnKeyOffIcon sx={{ width: '20px', color:'darkgrey' }} />
				</ListItemIcon>
				<ListItemText primary={title} />
			</ListItemButton>
		</Tooltip>
	);
};

export default EnableDisableMfaSideMenu;
